import { render, staticRenderFns } from "./MatchPayMismatchStep.vue?vue&type=template&id=44944dc6"
import script from "./MatchPayMismatchStep.vue?vue&type=script&lang=js"
export * from "./MatchPayMismatchStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports